import React, { useState, useEffect } from 'react';
import { getMoUDetails, signMoU } from '../services/mouService';
import './MoUDetailsPopup.css';

const MoUDetailsPopup = ({ mouId, account, onClose, onUpdate }) => {
  const [mou, setMou] = useState(null);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    console.log('MoU ID in MoUDetailsPopup:', mouId);
    fetchMoUDetails();
  }, [mouId, account]);

  const fetchMoUDetails = async () => {
    try {
      setLoading(true);
      console.log('Fetching MoU details for ID:', mouId);
      const mouDetails = await getMoUDetails(mouId);
      console.log('Fetched MoU details:', mouDetails);
      console.log('CreatedAt value:', mouDetails.createdAt);
      setMou(mouDetails);
      setError('');
    } catch (error) {
      console.error('Error fetching MoU details:', error);
      setError('Failed to fetch MoU details. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (timestamp) => {
    console.log('Formatting timestamp:', timestamp);
    if (!timestamp || timestamp === '0') {
      console.error('Invalid or zero timestamp:', timestamp);
      return 'Date not available';
    }
    try {
      const date = new Date(parseInt(timestamp) * 1000);
      console.log('Parsed date:', date);
      if (isNaN(date.getTime())) {
        throw new Error('Invalid date');
      }
      return date.toLocaleDateString();
    } catch (error) {
      console.error('Error formatting date:', error);
      return 'Error formatting date';
    }
  };

  const handleSign = async () => {
    try {
      await signMoU(mou.id, account);
      await fetchMoUDetails();
      onUpdate();
    } catch (error) {
      console.error('Error signing MoU:', error);
      setError('Failed to sign MoU. Please try again.');
    }
  };

  const handleViewOnExplorer = () => {
    const contractAddress = process.env.REACT_APP_CONTRACT_ADDRESS;
    const explorerUrl = process.env.REACT_APP_EARTH_EXPLORER_URL;

    if (!contractAddress || !explorerUrl) {
      console.error("Contract Address or Explorer URL is not set in environment variables");
      // Optionally, you can show an error message to the user here
      return;
    }

    const url = `${explorerUrl}/address/${contractAddress}`;
    window.open(url, '_blank');
  };

  if (loading) return <div className="mou-details-popup"><p>Loading MoU details...</p></div>;
  if (error) return <div className="mou-details-popup"><p className="error-message">{error}</p></div>;
  if (!mou) return <div className="mou-details-popup"><p>No MoU data available</p></div>;

  return (
    <div className="mou-details-popup">
      <div className="mou-document">
        <div className="mou-content">
          <div className="mou-header">
            <h1>Memorandum of Understanding</h1>
            <p className="mou-id">MoU ID: {mou.id}</p>
          </div>
          <div className="mou-body">
            <p>This Memorandum of Understanding (MoU) is entered into on {formatDate(mou.createdAt)} by and between:</p>
            <p><strong>Initiator:</strong> {mou.initiatorName} ({mou.initiator})</p>
            <p><strong>Counterparty:</strong> {mou.counterpartyName} ({mou.counterparty})</p>
            <h2>1. Purpose</h2>
            <p>{mou.content}</p>
            <h2>2. Term</h2>
            <p>This MoU shall commence on the date of signing and continue until terminated by mutual agreement of both parties.</p>
            <h2>3. Signatures</h2>
            <div className="signature-section">
              <div className="signature-box">
                <p>Initiator</p>
                <p className={mou.initiatorSigned ? "signed" : "not-signed"}>
                  {mou.initiatorSigned ? "Signed" : "Not Signed"}
                </p>
                {!mou.initiatorSigned && account.toLowerCase() === mou.initiator.toLowerCase() && (
                  <button onClick={handleSign}>Sign as Initiator</button>
                )}
              </div>
              <div className="signature-box">
                <p>Counterparty</p>
                <p className={mou.counterpartySigned ? "signed" : "not-signed"}>
                  {mou.counterpartySigned ? "Signed" : "Not Signed"}
                </p>
                {!mou.counterpartySigned && account.toLowerCase() === mou.counterparty.toLowerCase() && (
                  <button onClick={handleSign}>Sign as Counterparty</button>
                )}
              </div>
            </div>
          </div>
          <div className="mou-footer">
            <p>This MoU is stored on the Earth blockchain and cannot be altered once signed by both parties.</p>
          </div>
        </div>
        <div className="mou-actions">
          <button className="view-on-explorer-button" onClick={handleViewOnExplorer}>
            View on Explorer
            <svg className="external-link-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path>
              <polyline points="15 3 21 3 21 9"></polyline>
              <line x1="10" y1="14" x2="21" y2="3"></line>
            </svg>
          </button>
          <button className="close-button" onClick={onClose}>Close</button>
        </div>
      </div>
    </div>
  );
};

export default MoUDetailsPopup;
